import { useMemo, useRef } from "react";

import BulkActionsTable from "views/merchandise/tables/BulkActionsTable";
import { Flex } from "../../../../styled-system/jsx";
import { useDSPAdCreatives } from "../hooks/useDSPProductAdCreatives";
import { useAppSelector } from "redux/hooks";
import { toTitleCase } from "utils/formatText";

const getFullLanguageName = (languageCode) => {
  const languageNames = new Intl.DisplayNames(["en"], { type: "language" });
  return languageNames.of(languageCode);
};

export const CreativeSelector = ({ selectedCreatives = [], setSelectedCreatives = () => {} }) => {
  const tableRef = useRef();
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { data } = useDSPAdCreatives();

  const tableData = useMemo(() => {
    return data;
  }, [data]);

  const columnSpecs = useMemo(() => {
    return [
      {
        key: "format",
        compareKey: null,
        options: {
          metric: {
            id: "format",
            format: "text",
            accessor: (d) => d,
            name: "Format",
          },
          formatter: (row) => {
            return <span>{toTitleCase(row.adCreativeFormatProperties.adCreativeFormatType)}</span>;
          },
          width: 150,
        },
      },
      {
        key: "language",
        compareKey: null,
        options: {
          metric: {
            id: "language",
            format: "text",
            accessor: (d) => d,
            name: "Language",
          },
          formatter: (row) => {
            return <span>{getFullLanguageName(row.language)}</span>;
          },
          width: 150,
        },
      },
      {
        key: "size",
        compareKey: null,
        options: {
          metric: {
            id: "size",
            format: "text",
            accessor: (d) => d,
            name: "Size",
          },
          formatter: (row) => {
            return (
              <span>{row.adCreativeFormatProperties.creativeSizes?.length === 0 ? "Responsive" : "Multi-size"}</span>
            );
          },
          width: 150,
        },
      },
    ];
  }, []);

  return (
    <Flex direction="column">
      <BulkActionsTable
        noDataText={`No creatives are currently available.`}
        marketPlace={marketPlace}
        tableRef={tableRef}
        tableId={`dspLineItemCreativeAssocationTable`}
        titleCol={{
          id: "name",
          isStatic: true,
          Header: "Name",
          accessor: "name",
          style: { width: "150px" },
          width: "150px",
          Cell: ({ row }) => {
            const { name } = row;
            return <span>{name}</span>;
          },
          filterMethod: () => {
            return;
          },
          Filter: () => null,
        }}
        columnSpecs={columnSpecs}
        data={tableData}
        hideFilterToggleIcon={true}
        isExpandable={false}
        defaultSorted={[{ id: "name", desc: false }]}
        getSearchCriteria={(row) => {
          return `${row.name}`;
        }}
        minRows={0}
        setSelected={setSelectedCreatives}
        selected={selectedCreatives}
        isSelectable={true}
        selectionKey={"adCreativeId"}
        bulkActionOptions={[]}
        hideBulkActionsButton={true}
        hideBottomPagination={true}
        defaultPageSize={5}
      />
    </Flex>
  );
};
